import { getFieldFromPushData, getMatchingFieldsFromSession } from "../../util/functions";

import { Answer } from "../Steps/InputFields/InputFields.types";
import { IAppContext } from "../../util/context";
import { StepData } from "../FormViewer/FormViewer.types";
import { StepField } from "../Steps/Step.types";
import { Condition } from "../FormClient/FormClient.types";

export const handleScrollIntoView = () => {
  const element = document.getElementById("formClient");
  const header = document.querySelector(".header.sticky-top") as HTMLElement;

  if (element) {
    const scrollPosition =  header ? element.offsetTop - header.offsetHeight : element.offsetTop;
    window.scrollTo({
      top: scrollPosition - 15,
      behavior: "smooth",
    });
  }
};

export const handleDuplicateStep = (stepData: StepData) => {
  const { uuid } = stepData;

  const duplicateStepIndex = window.sessionLayer.lead.lead_data.findIndex((step: StepData) => step.uuid === uuid);
  if (duplicateStepIndex > -1) {
    window.sessionLayer.lead.lead_data[duplicateStepIndex] = stepData;
  } else {
    window.sessionLayer.lead.lead_data.push(stepData);
  }
}

export const getNextStepIndex = (activeStepIndex: number, stepData: StepData, steps: any, context: IAppContext) => {
  const { updatePrevStepIndex } = context;
  const { 
    settings: { next_step, last_step },
    answer = {} as Answer,
    uuid
  } = stepData;

  const { next_step_answer } = answer;

  const conditionalNextStep = next_step_answer || next_step;
  const prevStepIndex = steps.findIndex((step: StepField) => step.stepSettings[0]?.uuid === uuid);
  updatePrevStepIndex(prevStepIndex);

  if (conditionalNextStep) {
    // If the answer provided in the step has a next_step_answer, set the active step to the next step
    // OR if the step has a next_step, set the active step to that step
    
    return steps.findIndex((step: StepField) => step.stepSettings[0]?.uuid === conditionalNextStep);
  }
  else if (!last_step) {
    // If the step doesn't have a next_step, set the active step to the next step
    return activeStepIndex + 1;
  }   
  else if (last_step) {
    // If the step is last step, find success page index and return it
    return steps.findIndex((step: StepField) => step.isSuccessPage);
  } 
  else {
    return 0;
  }
}

export const handleStatus = (response: {res: Response, details: string} | undefined, context: IAppContext) => {
  const { updateDisableButton, updateErrorMessage } = context;
  if(response) {
    const { status } = response.res;
    if(status < 200 || status > 300){
      updateErrorMessage(response?.details);
    }
  }
  return updateDisableButton(false);
}

export const handleBackClick = (context: IAppContext) => {
  const { updateActiveStepIndex, updateBreadcrumb, activeStepIndex, breadcrumb } = context;
  const prevStepIndex = breadcrumb[breadcrumb.indexOf(activeStepIndex) - 1];
  const newBreadcrumb = breadcrumb.slice(0, breadcrumb.indexOf(prevStepIndex) + 1);
  updateBreadcrumb(newBreadcrumb);

  updateActiveStepIndex(prevStepIndex);
};

export const checkIfConditionsMet = (conditions: Array<Condition>) => {
  const conditionalFields: any[] = getMatchingFieldsFromSession(conditions);

  const existingEmailField = conditionalFields.find((item: any) => { return item.field_crm_id === "email" && item.field_session_source === "submitted_data" });
  
  const pushEmailToSession = existingEmailField && !getFieldFromPushData("email") && !getFieldFromPushData("contact_id");
  pushEmailToSession && window.sessionLayer.pushToSession("email", existingEmailField.field_value);
  
  return conditionalFields.some((field: any) => conditions.some((item: any) => item.field === field.field_crm_id));
}